export const EledaMessagesDE = {
  undefinedOrNull: "⍰",
  wahr: "wahr",
  false: "false",
  submitBtn: "Bestätigen",
  nextActBtn: "Nächstes Problem",

  defaultMessageAllSolutionsFound: {
    neutral: ["Bravo, du hast die Aktivität 🤩 bestanden"],
    kids: ["Gut gemacht, du hast die Aktivität 🤩"],
    formal: ["Glückwunsch, Sie haben die Aktivität erfolgreich abgeschlossen"],
  },
  defaultMessageAllSolutionsNotFound: {
    neutral: ["Du hast nicht alle Antworten in der Aktivität gefunden."],
    kids: [
      "Du hast nicht alle Antworten der Aktivität gefunden, aber lass dich nicht entmutigen 😉",
    ],
    formal: [
      "Sie haben nicht alle Antworten der Aktivität gefunden, aber lassen Sie sich nicht entmutigen.",
    ],
  },

  defaultMessageAllSolutionsNotFoundButRemainedAttempts: {
    neutral: [
      "Du hast nicht alle Antworten der Aktivität gefunden, aber du kannst deine Antworten noch korrigieren.",
    ],
    kids: [
      "Du hast nicht alle Antworten in der Aktivität gefunden, aber du kannst deine Antworten noch korrigieren. 😉",
    ],
    formal: [
      " Sie haben nicht alle Antworten in der Aktivität gefunden, aber Sie können Ihre Antworten noch korrigieren.",
    ],
  },

  defaultMessageAllSolutionsNotFoundButRemainedQuestions: {
    neutral: [
      "Du hast nicht alle Antworten in der Aktivität gefunden, aber es gibt noch Fragen.",
    ],
    kids: [
      "Du hast nicht alle Antworten in der Aktivität gefunden, aber es gibt noch Fragen. 😉",
    ],
    formal: [
      " Sie haben nicht alle Antworten der Aktivität gefunden, aber es gibt noch Fragen.",
    ],
  },

  defaultMessageSolutionFound: {
    neutral: [
      "🟢 Glückwunsch, Sie haben die richtige Antwort gefunden",
      "🟢 Richtig!",
      "🟢 Noch eine gute Antwort, herzlichen Glückwunsch !",
      "🟢 Richtige Antwort. Well done !",
      "🟢 Das ist richtig ! Great job !",
      "🟢 Richtige Antwort !",
      "🟢 Richtige Antwort !",
    ],
    kids: [
      "🟢 Glückwunsch, du hast die richtige Antwort gefunden",
      "🟢 Waw ! Richtig!",
      "🟢 Noch eine gute Antwort, Glückwunsch !",
      "🟢 YES ! Richtige Antwort ! Gut gemacht !",
      "🟢 Das ist richtig! Great job !",
      "🟢 Ja, weiter so !",
      "🟢 Ein neues Mathegenie ist geboren! Richtige Antwort !",
      "🟢 Woop woop ! Richtige Antwort !",
    ],
    formal: [
      "🟢 Herzlichen Glückwunsch, Sie haben die richtige Antwort gefunden",
      "🟢 Richtig !",
      "🟢 Noch eine gute Antwort, herzlichen Glückwunsch !",
      "🟢 Richtige Antwort. Well done !",
      "🟢 That's right.",
      "🟢 Richtige Antwort.",
      "🟢 Richtige Antwort.",
    ],
  },

  defaultMessageSolutionFoundAtFirstAttempt: {
    neutral: "🟢 Du hast es beim ersten Mal richtig gemacht, Glückwunsch!",
    kids: "🟢 Wow, du hast es gleich beim ersten Mal richtig gemacht!!!",
    formal:
      "🟢 Du hast es beim ersten Mal richtig gemacht, herzlichen Glückwunsch.",
  },

  defaultMessageSolutionNotFound: {
    neutral: [
      "🔴 Du hast die Lösung dieses Mal nicht gefunden...",
      "🔴 Falsche Antwort.",
      "🔴 Es ist nicht die richtige Antwort...",
    ],
    kids: [
      "🔴 Du hast die Lösung dieses Mal nicht gefunden...",
      "🔴 Falsche Antwort, Mist! Nächstes Mal machst du es richtig!",
      "🔴 Das ist nicht die richtige Antwort... Ein bisschen mehr Training und du wirst es schaffen !",
    ],
    formal: [
      "🔴 Du hast die Lösung dieses Mal nicht gefunden...",
      "🔴 Falsche Antwort.",
      "🔴 Es ist nicht die richtige Antwort...",
    ],
  },
  defaultMessageSolutionNotFoundButRemainingAttempts: {
    neutral: [
      "🟠 Du hast die richtige Antwort nicht gefunden, aber lass es uns noch einmal versuchen.",
      "🟠 Falsche Antwort. Du kannst es noch einmal versuchen.",
      "🟠 Falsche Antwort... Geben Sie nicht auf und versuchen Sie es noch einmal.",
      "🟠 Du hast es nicht richtig gemacht, aber du kannst deine Antwort noch ändern.",
      "🟠 Das ist nicht die richtige Antwort... Try again.",
    ],
    kids: [
      "🟠 Du hast nicht die richtige Antwort gefunden, aber lass es uns noch einmal versuchen!",
      "🟠 Falsche Antwort, schade! Atme tief durch und konzentriere dich, du wirst die richtige Antwort finden!",
      "🟠 Falsche Antwort... Los, los, los! Nicht aufgeben !",
      "🟠 Du hast es nicht richtig gemacht, aber du kannst deine Antwort immer noch ändern.",
      "🟠 Falsche Antwort, scheiße! Du kannst es richtig machen, wenn du deine Antwort korrigierst !",
      "🟠 Das ist nicht die richtige Antwort... Dein nächster Versuch wird die richtige sein !",
      "🟠 Arg, falsche Antwort ! Nicht aufgeben!",
    ],
    formal: [
      "🟠 Du hast nicht die richtige Antwort gefunden, aber lass es uns noch einmal versuchen.",
      "🟠 Falsche Antwort. Du kannst es noch einmal versuchen.",
      "🟠 Falsche Antwort... Geben Sie nicht auf und versuchen Sie es noch einmal.",
      "🟠 Du hast es nicht richtig gemacht, aber du kannst deine Antwort noch ändern.",
      "🟠 Das ist nicht die richtige Antwort... Try again.",
    ],
  },

  defaultMessageSolution: "Die Lösung ist ",

  defaultMessageMCQSolutionAnswer: "ist die Lösung",
  defaultMessageReorderSolutionFound: "Alle Elemente sind gut geordnet",
  defaultMessageReorderSolutionNotFound:
    "Einige Elemente befinden sich an der falschen Stelle",
  defaultMessageAssociateSolutionFound:
    "Alle Elemente sind gut miteinander verbunden",
  defaultMessageAssociateSolutionNotFound:
    "Einige Elemente werden fälschlicherweise assoziiert",
  questionOpenExpressionDeprecatedMode:
    "Wie schreibt man einen mathematischen Ausdruck ?",
  questionOpenExpressionDeprecatedModeMathSymbols: `
    Verwenden Sie <b>*</b> für multiplizieren. z.B.: a*b bedeutet a × b  <br/>
    Verwenden Sie <b>/</b> für Fraktion. z.B.: 1/4 bedeutet ¼  <br/>
    Verwenden Sie <b>^</b> für Potenzen. z.B.: a^2 bedeutet a² <br/>
    Verwenden Sie <b>sqrt()</b> für die Quadratwurzel. z.B.: sqrt(a) bedeutet √a
    `,

  //ERRORS used by manageErrors
  emptyMultipleChoiceQuestion:
    "Fehler in der Tätigkeitsgestaltung: Bei dieser Frage gibt es keine Wahlmöglichkeit",
  emptyQuestionReorder:
    "Fehler im Aktivitätsdesign: Es gibt keine Elemente zum Neuordnen",
  notAFractionQuestionFraction:
    "Fehler in der Aufgabenstellung: Richtige Antwort (Bruch) scheint kein Bruch zu sein",
  emptyQuestionAssociate:
    "Fehler im Aktivitätsdesign: Es gibt keine Elemente zu assoziieren",
  emptyQuestionOpen:
    "Fehler im Aktivitätsdesign: Es gibt keine Lösung in dieser Frage",
  notElementBoardQuestionFigure:
    "Fehler im Aktivitätsdesign: In dieser Frage gibt es keine grafische Tafel",
  notAExpressionQuestionExpression:
    "Fehler im Aktivitätsdesign: Richtige Antwort (Ausdruck) scheint kein Ausdruck zu sein",
};
